import { render, staticRenderFns } from "./privatePublicCheckBox.vue?vue&type=template&id=473de870&scoped=true&"
import script from "./privatePublicCheckBox.vue?vue&type=script&lang=js&"
export * from "./privatePublicCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./privatePublicCheckBox.vue?vue&type=style&index=0&id=473de870&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473de870",
  null
  
)

export default component.exports